module.exports = __webpack_public_path__ + "img/at.b24a301b.jpg";